import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function Resources() {
    return (
        <div className="bg-[#F5F9FF] min-h-screen">

            {/* NAVBAR */}
            <Navbar />

            {/* HERO */}
            <section className="py-20 text-center">
                <div className="max-w-4xl mx-auto px-6">

                    <h1 className="text-[42px] md:text-[56px] font-bold text-[#2563EB]">
                        Resources
                    </h1>

                    <p className="mt-4 text-gray-600 text-[18px] max-w-2xl mx-auto">
                        Learn, grow, and succeed with WamGlammz. Explore guides, tools, and insights designed for both clients and professionals.
                    </p>

                </div>
            </section>

            {/* RESOURCE CARDS */}
            <section className="max-w-5xl mx-auto px-6 md:px-12">

                <div className="grid md:grid-cols-2 gap-8">

                    {/* CARD 1 */}
                    <div className="bg-white p-8 rounded-2xl shadow-[0_20px_40px_rgba(0,31,42,0.08)]">
                        <h3 className="text-xl font-semibold text-[#2563EB] mb-4">
                            Beauty & Lifestyle Guides
                        </h3>

                        <p className="text-gray-600 text-sm leading-[26px]">
                            Access expert-written guides covering beauty trends, self-care tips, event preparation, and lifestyle inspiration to help clients and professionals make confident choices.
                        </p>
                    </div>

                    {/* CARD 2 */}
                    <div className="bg-white p-8 rounded-2xl shadow-[0_20px_40px_rgba(0,31,42,0.08)]">
                        <h3 className="text-xl font-semibold text-[#2563EB] mb-4">
                            Tutorials & How-To Content
                        </h3>

                        <ul className="space-y-2 text-gray-600 text-sm">
                            <li>• Step-by-step makeup & hairstyling tutorials</li>
                            <li>• Booking and appointment guides</li>
                            <li>• Insider tips from professionals</li>
                        </ul>
                    </div>

                    {/* CARD 3 */}
                    <div className="bg-white p-8 rounded-2xl shadow-[0_20px_40px_rgba(0,31,42,0.08)]">
                        <h3 className="text-xl font-semibold text-[#2563EB] mb-4">
                            Resources for Professionals
                        </h3>

                        <ul className="space-y-2 text-gray-600 text-sm">
                            <li>• Profile & portfolio setup guides</li>
                            <li>• Business growth strategies</li>
                            <li>• Booking optimization tips</li>
                        </ul>
                    </div>

                    {/* CARD 4 */}
                    <div className="bg-white p-8 rounded-2xl shadow-[0_20px_40px_rgba(0,31,42,0.08)]">
                        <h3 className="text-xl font-semibold text-[#2563EB] mb-4">
                            Industry Insights & Trends
                        </h3>

                        <p className="text-gray-600 text-sm leading-[26px]">
                            Stay updated with the latest beauty, fashion, and lifestyle trends. Discover insights that help professionals stay competitive and help clients explore what’s new.
                        </p>
                    </div>

                    {/* CARD 5 */}
                    <div className="bg-white p-8 rounded-2xl shadow-[0_20px_40px_rgba(0,31,42,0.08)]">
                        <h3 className="text-xl font-semibold text-[#2563EB] mb-4">
                            Help Center & FAQs
                        </h3>

                        <ul className="space-y-2 text-gray-600 text-sm">
                            <li>• Booking & payment support</li>
                            <li>• Troubleshooting guides</li>
                            <li>• Platform navigation help</li>
                        </ul>
                    </div>

                    {/* CARD 6 */}
                    <div className="bg-white p-8 rounded-2xl shadow-[0_20px_40px_rgba(0,31,42,0.08)]">
                        <h3 className="text-xl font-semibold text-[#2563EB] mb-4">
                            Downloads & Tools
                        </h3>

                        <ul className="space-y-2 text-gray-600 text-sm">
                            <li>• Contracts & templates</li>
                            <li>• Event planning checklists</li>
                            <li>• Marketing resources</li>
                        </ul>
                    </div>

                </div>

            </section>

            {/* COMMUNITY SECTION */}
            <section className="max-w-5xl mx-auto px-6 md:px-12 mt-20">

                <div className="bg-gradient-to-r from-[#0A3FB6] to-[#2FB4FF] text-white rounded-2xl p-10 text-center">

                    <h2 className="text-2xl font-semibold">
                        Community & Updates
                    </h2>

                    <p className="mt-4 text-blue-100 max-w-2xl mx-auto leading-[26px]">
                        Stay connected with platform updates, announcements, and community news.
                        Discover upcoming features, promotions, and opportunities within the WamGlammz ecosystem.
                    </p>

                </div>

            </section>

            {/* PREMIUM SEPARATOR */}
            <div className="relative">
                <div className="h-20 bg-gradient-to-b from-transparent to-[#F5F9FF]" />
                <div className="flex justify-center">
                    <div className="w-[60%] h-[1px] bg-gradient-to-r from-transparent via-blue-300 to-transparent" />
                </div>
            </div>

            {/* FOOTER */}
            <Footer />

        </div>
    );
}